(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AppointmentTypeDialogController', AppointmentTypeDialogController);

    AppointmentTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AppointmentType'];

    function AppointmentTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AppointmentType) {
        var vm = this;

        vm.appointmentType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.appointmentType.id !== null) {
                AppointmentType.update(vm.appointmentType, onSaveSuccess, onSaveError);
            } else {
                AppointmentType.save(vm.appointmentType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:appointmentTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
